import { useCallback } from "react";
import { t } from "@/i18n-js/instance";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import type { TemplateBlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Preview } from "./Preview";

export interface TemplatePreviewProps {
  block: TemplateBlockExport;
  isElementType?: boolean;
  isOverlay?: boolean;
}

export const TemplatePreview = ({
  block,
  isOverlay = false,
  isElementType = false,
}: TemplatePreviewProps) => {
  const addBlocksToRoot = useBuilderStore(state => state.addBlocksToRoot);
  const data = block.templateData;
  const i18nKey = block.meta.nameI18n;
  const fallbackName = block.meta.name;
  const name = i18nKey
    ? t(i18nKey, { defaultValue: fallbackName })
    : fallbackName;

  const handleAddTemplate = useCallback(() => {
    if (isOverlay) return;
    addBlocksToRoot(data);
  }, [addBlocksToRoot, data, isOverlay]);

  return (
    <Preview
      isElementType={isElementType}
      name={name}
      block={block}
      onAddBlock={handleAddTemplate}
    />
  );
};
